import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SkeletonList } from "@/components/Skeletons";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="mx-auto max-w-3xl px-4 py-16">
                <SkeletonList rows={4} />
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/acceder" state={{ from: location.pathname }} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/app" replace />;
    }
    return children;
}
